


















// vue
import { defineComponent, ref, onMounted } from '@vue/composition-api';

// services
import { useService } from '@/vue3/api/services';

// store
import { useStore } from '@/store';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';

// components
import GridEditor from '@/vue3/components/GridEditor.vue';
import GeoRecordModelEditor from '@/vue3/components/GeoRecordModelEditor.vue';

// config
import tableColumns from '@/vue3/configs/table/organizationsConfig';

export default defineComponent({
    components: {
        GridEditor,
        GeoRecordModelEditor,
    },
    setup() {
        // hooks
        const { getAllGeoRecordModels, deleteGeoRecordModel, getAllAsTree } =
            useService();
        const store = useStore();
        const { treeToArray } = useGeoRecord();

        // reactive
        const geoRecords = ref<any[]>([]);

        // lifecycle
        onMounted(async () => {
            let courseSchemaId = store.getters.currentCourseSchema.id;
            geoRecords.value = treeToArray(await getAllAsTree(courseSchemaId));
        });

        return {
            geoRecords,
            tableColumns,
            getAllGeoRecordModels,
            deleteGeoRecordModel,
            GeoRecordModelEditor,
        };
    },
});
